module.exports = __webpack_public_path__ + "static/06-88289abca4b69920b8359cf23554faed.jpg";